// One artwork = one generation session. The sessionId lives in localStorage
// so a page reload mid-work resumes the same session, and is only replaced
// when the visitor deliberately starts a new artwork from the home page.
// Options/Checkout only READ this key (to preview the chosen image); the
// order itself is placed with the explicit generatedImageId in the URL.
export const GENERATION_SESSION_KEY = "ops-last-session";

function newId() {
  return crypto.randomUUID?.() ?? `s-${Date.now()}`;
}

/** Current in-progress session (resume after reload); creates one if none. */
export function getOrCreateGenerationSessionId(): string {
  try {
    const existing = window.localStorage.getItem(GENERATION_SESSION_KEY);
    if (existing) return existing;
    const fresh = newId();
    window.localStorage.setItem(GENERATION_SESSION_KEY, fresh);
    return fresh;
  } catch {
    return newId();
  }
}

/** Start a brand-new artwork: replaces the stored session. Old
 *  generated_images stay in the DB untouched; they're just no longer listed. */
export function startNewGenerationSession(): string {
  const fresh = newId();
  try {
    window.localStorage.setItem(GENERATION_SESSION_KEY, fresh);
  } catch {
    // Storage disabled: Create falls back to a per-mount session id.
  }
  return fresh;
}
